import { InputProps, SelectProps } from "@chakra-ui/react";

export function commonInputStyles() {
  return {
    size: "lg",
    py: 6,
    _placeholder: {
      color: "brand.800",
      fontSize: "sm",
    },
    backgroundColor: "#342228",
    border: "3px solid",
    borderColor: "#7d485a",
    color: "text.main",
    borderRadius: "lg",
  } satisfies InputProps | SelectProps;
}
